import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isAfter, parseISO } from 'date-fns';
import { Box } from '@mui/material';
import DashboardBlock from 'components/shared/blocks/DashboardBlock';
import LoadingBlock from 'components/shared/blocks/LoadingBlock';
import LargeSessionCard from 'components/shared/cards/session/LargeSessionCard';
import PaginatedList from 'components/shared/lists/PaginatedList';
import { isMembershipActive } from 'common/utils/session';
import { dimIfPastSx } from 'common/utils/sessionColor';

function NextGroupSessionsList({ emptyMessage, itemsPerPage = 5 }) {
  const { t } = useTranslation(['sessions']);

  const sessions = useSelector((state) => state.groupSession.data.myGroupSessions);
  const sessionStatus = useSelector((state) => state.groupSession.status.general);
  const role = useSelector((state) => state.auth.user.role);
  const membershipStatus = useSelector((state) => state.auth.user?.membership_status);

  const now = new Date();
  const nextSessions = sessions
    .filter((s) => s.status === 'SCHEDULED' && isAfter(parseISO(s.start_date), now))
    .sort((a, b) => parseISO(a.start_date) - parseISO(b.start_date))
    .slice(0, itemsPerPage)
    .map((s) => ({ ...s, trainer_id: s.trainer }));

  return (
    <DashboardBlock
      title={t('nextTrainingSessions', { ns: 'sessions' })}
      titleNote={t('nextNWeeks', { num: 2, ns: 'common' })}>
      <LoadingBlock
        emptyBlockProps={{ imageType: 'man', message: emptyMessage }}
        isValid={nextSessions.length > 0}
        skeletonProps={{ height: 100, rows: itemsPerPage }}
        status={sessionStatus}
        type="table">
        {/* Membresía no vigente (mora/inactivo): se opacan las cards de clases Active Plus. */}
        <Box sx={dimIfPastSx(!isMembershipActive(membershipStatus))}>
          <PaginatedList
            items={nextSessions}
            renderItem={(item) => <LargeSessionCard data={item} userRole={role} key={item.id} />}
          />
        </Box>
      </LoadingBlock>
    </DashboardBlock>
  );
}

NextGroupSessionsList.propTypes = {
  emptyMessage: PropTypes.string.isRequired,
  itemsPerPage: PropTypes.number
};

export default NextGroupSessionsList;
